import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../../util/apiClient";
import EditForm from './EditForm';
import Formulaire from "./Formulaire";
import { addModuleDroits, editModuleDroit, setObjModuleDroit, setOpenDialogModuleDroit, setValueEdit } from "./moduleDroitSlice";
import MyDialogComponent from '../../../../components/Common/MyDialogComponent';





const AddModuleDroit = () => {

    //redux
    const dispatch = useDispatch()
    const { openDialogModuleDroit, objModuleDroit, valueEdit } = useSelector((state: IReduxState) => state.modulesDroit);

    //hooks
    const [valueModuleDroit, setValueModuleDroit] = useState("");


    const handleSave = async () => {
        try {
            const apiPayload = { libModuleDroit: valueModuleDroit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creermoduledroit", apiPayload)
            if (res.status === 1) {
                const newModuleDroit = { ...res.data, id: res.data.idModuleDroit, libelle: res.data.libModuleDroit }
                dispatch(addModuleDroits(newModuleDroit))
                dispatch(setOpenDialogModuleDroit(false))
            } else {
                console.log("status !==1")
            }
        } catch (error) {
            console.log("🚀 ~ file: AddModuleDroit.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    }


    const editItem = async () => {
        try {
            const apiPayload = { idModuleDroit: objModuleDroit.idModuleDroit, libModuleDroit: valueEdit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifiermoduledroit", apiPayload)
            if (res.status === 1) {
                const newModuleDroit = { ...res.data, id: res.data.idModuleDroit, libelle: res.data.libModuleDroit }
                dispatch(editModuleDroit(newModuleDroit))
                dispatch(setOpenDialogModuleDroit(false))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModuleDroit.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };

    const handleOpen = () => {
        dispatch(setOpenDialogModuleDroit(true));
        dispatch(setObjModuleDroit({}));
        setValueModuleDroit("")
    };

    const handleClose = () => {
        dispatch(setOpenDialogModuleDroit(false));
    };


    return (
        <div>
            <MyDialogComponent
                dialogTitle={`${Object.keys(objModuleDroit).length > 0 ? "Modifier le module" : "Créer un module"}`}
                dialogContent={
                    Object.keys(objModuleDroit).length > 0
                        ? <EditForm setValueEdit={setValueEdit} valueEdit={valueEdit} />
                        : <Formulaire setValueModuleDroit={setValueModuleDroit} valueModuleDroit={valueModuleDroit} />
                }
                handleSave={
                    Object.keys(objModuleDroit).length > 0
                        ? editItem
                        : handleSave
                }
                openDialog={openDialogModuleDroit}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />
        </div>
    );
}

export default AddModuleDroit;
